import fetcher from 'scripts/api/backoffice/fetcher'

export default () => async (path) => {
  const response = await fetcher(`/carrier-tracking/${path}`)

  if (response.status !== 200 || response.redirected === true) {
    throw new Error('Bad Request')
  }

  const body = await response.json()

  return body
}
